export default __webpack_public_path__ + "static/media/tlp.23426b11.png";